import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

interface CnInput {
  [key: string]: unknown;
}

export function cn(...inputs: Array<string | number | CnInput | undefined | null | boolean>): string {
  return twMerge(clsx(inputs));
}

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
